import { useQuery } from '@hooks/reactQuery';

import { getBenetelAlarm } from '@api/alarmManagement';

import { extractQueryParams } from '@utils/common';

import { IAlarmOran } from '@interfaces/alarms/alarm';

import { EUserRoles } from '@enums/common';

import { ALARM_BENETEL } from '@constants/queryKeys';

interface IUseQueryAlarmBenetelReturn {
	isLoadingAlarmBenetel: boolean;
	alarm?: IAlarmOran;
}

export const useQueryAlarmBenetel = (id?: string): IUseQueryAlarmBenetelReturn => {
	const {
		data,
		isLoading,
	} = useQuery({
		queryKey: [ALARM_BENETEL, { id }],
		queryFn: extractQueryParams(getBenetelAlarm),
		enabled: [!!id],
		allowedRoles: [EUserRoles.networkOperatorAlarmManager],
		refetchOnWindowFocus: false,
	});

	return {
		isLoadingAlarmBenetel: isLoading,
		alarm: data,
	};
};
